<h3 mat-dialog-title>{{ data.title | translate }}</h3>
<div mat-dialog-content>
  {{ data.body | translate }}
</div>
<div mat-dialog-actions fxLayoutAlign="center center">
  <button
    mat-raised-button
    *ngIf="data.no != null"
    class="me-3"
    (click)="no()"
    style="color: green"
  >
    {{ data.no }}
  </button>
  <span fxFlex></span>
  <button mat-raised-button (click)="yes()" style="color: #d62300">
    {{ data.yes | translate }}
  </button>
</div>